import React, { useContext, useEffect, useState } from 'react';
import { Backdrop, Box, Typography, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SettingsContext } from '../context/SettingsContext';

export default function LoaderOverlay({ overrideLoader, overrideOpen, forceMode }) {
  const settings = useContext(SettingsContext) || {};
  const theme = useTheme();

  const loaderFromSettings = settings.loader || {};
  const loader = overrideLoader || loaderFromSettings || {};

  const initialOpen = overrideOpen !== undefined ? Boolean(overrideOpen) : Boolean(loader && loader.enabled);
  const [open, setOpen] = useState(initialOpen);

  useEffect(() => {
    const active = overrideLoader || loaderFromSettings;
    if (!active || !active.enabled) return;
    setOpen(true);
    if (active.customJS && typeof active.customJS === 'string' && active.customJS.trim()) {
      try {
        // eslint-disable-next-line no-new-func
        new Function(active.customJS)();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Loader customJS error:', err);
      }
    }
    const duration = Number(active.durationMs) || 800;
    const t = setTimeout(() => setOpen(false), duration);
    return () => clearTimeout(t);
    // Only re-run when the object reference changes
  }, [overrideLoader, loaderFromSettings]);

  useEffect(() => {
    if (overrideOpen !== undefined) setOpen(Boolean(overrideOpen));
  }, [overrideOpen]);

  // If preview explicitly requested via overrideOpen, show regardless of enabled flag
  if (!loader || (!loader.enabled && !overrideOpen)) return null;

  const mode = forceMode === 'dark' || forceMode === 'light' ? forceMode : theme.palette.mode;

  const bg = mode === 'dark'
    ? (loader.backgroundColorDark || loader.backgroundColor || theme.palette.background.default)
    : (loader.backgroundColorLight || loader.backgroundColor || '#ffffff');

  const spinnerSrc = mode === 'dark' ? (loader.spinnerDark || loader.spinner) : (loader.spinnerLight || loader.spinner);

  return (
    <Backdrop open={open} sx={{ zIndex: 14000, bgcolor: bg, color: '#fff', flexDirection: 'column' }}>
      <Box sx={{ textAlign: 'center' }}>
        {spinnerSrc ? (
          <Box component="img" src={spinnerSrc} alt="loader" sx={{ width: 96, height: 96, mb: 2, objectFit: 'contain' }} />
        ) : (
          <CircularProgress size={64} thickness={4} color="inherit" sx={{ mb: 2 }} />
        )}
        {loader.message && <Typography variant="h6" sx={{ color: theme.palette.mode === 'dark' ? '#fff' : '#111' }}>{loader.message}</Typography>}
      </Box>
    </Backdrop>
  );
}
